import React from 'react';
import { Link } from 'react-router-dom';

export default function Header({ back }) {
  return (
    <header className="site-header">
      <div className="width site-header__inner">
        <div className="site-header__slot">
          {back ? (
            <Link to="/" className="ghost-button ghost-button--icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" width="20">
                <path
                  fill="currentColor"
                  d="M560-253 333-480l227-227 56 57-170 170 170 170-56 57Z"
                />
              </svg>
              Back
            </Link>
          ) : (
            <span className="pill-label">Minimal crypto tracker</span>
          )}
        </div>

        <h1 className="site-logo">
          <Link to="/">CoinZ</Link>
        </h1>

        <div className="site-header__slot site-header__slot--end">
          <a
            className="ghost-button"
            href="https://github.com/Pranjal0301"
            target="_blank"
            rel="noreferrer"
          >
            GitHub
          </a>
        </div>
      </div>
    </header>
  );
}
